const defaultQueryForm = {
    nombre: '',
    lastname: '',
    documento: '',
    tipo_documento: null,
    telefono: '',
    estadoCliente: '',
    estadoOferta: [],
    processed: null,
    tipoOferta: [],
    tipoGestion: [],
    email: '',
    direccion: '',
    cp: '',
    localidad: '',
    fecha_contacto: [],
    updated_on: [],
    origenBbdd: [],
    segmento: null,
    comercial: null,
    tipo_comercial: null,
    ispActual: null,
    cups: null,
    iban: null,
    fecha_agendado: [],
    fecha_venta: [],
    oferta: [],
    razon_no_interesado: null,
    notes: null,
    opciones_tipo_llamada: null,
    opciones_no_interesado: null,

    contractIsp: null,
    estadoServicio: null,
    contractSegment: null,
    contractTariffCategory: null,
    contractServices: [],
    notContractServices: [],
    contractPermanenceEnding: [],
    contractServiceState: null,
    contractPackageId: null,
    contractSfid: null
}

export { defaultQueryForm };
